import PropTypes from 'prop-types';

export const PARTICIPANT__AUTHORIZE_IN_PREVIEW = 'PARTICIPANT__AUTHORIZE_IN_PREVIEW';
export const PARTICIPANT__CREATE_IMPRESSION = 'PARTICIPANT__CREATE_IMPRESSION';
export const PARTICIPANT__RESET = 'PARTICIPANT__RESET';
export const PARTICIPANT__USE_EMAIL = 'PARTICIPANT__USE_EMAIL';

export const PARTICIPANT__SHAPE_ITEM = PropTypes.shape({
  providerEmail: PropTypes.string,
  email: PropTypes.string,
  firstName: PropTypes.string,
  fullName: PropTypes.string,
  id: PropTypes.string,
  lastName: PropTypes.string,
});
